import { styled } from '@mui/material/styles';
import { UploadManagerIcon } from './UploadManagerIcon';
import { UploadManagerStatus } from './UploadManagerStatus';
import CancelIcon from '@/assets/cancel2.svg?react';
import IconButton from '../IconButton/IconButton';

const UploadManagerItem = ({
  status,
  fileName,
  progress,
  message,
  onCancel,
}: {
  status: 'pending' | 'completed' | 'failed';
  fileName: string;
  progress?: number;
  message?: string;
  onCancel: () => void;
}) => {
  return (
    <Root>
      <UploadManagerIcon status={status} />
      <Description>
        <div>{fileName}</div>
        <UploadManagerStatus
          status={status}
          progress={progress}
          message={message}
        />
      </Description>
      {status === 'pending' ? (
        <IconButton onClick={onCancel} aria-label="Cancel upload">
          <StyledCancelIcon />
        </IconButton>
      ) : null}
    </Root>
  );
};

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: '10px 16px',
  borderRadius: theme.radii.xxs,
  border: `1px solid ${theme.palette.grey200}`,
}));

const Description = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  fontSize: 14,
  fontWeight: 500,
  lineHeight: '20px',
}));

const StyledCancelIcon = styled(CancelIcon)(({ theme }) => ({
  path: {
    stroke: theme.palette.white,
  },
}));

export default UploadManagerItem;
